import {Nav, Navbar} from "rsuite";
import {history} from "../../../_helpers";
import logo from "../../../assets/img/logonotext.png";
import React, {useEffect, useState, useRef} from "react";
import {toggleMenu} from "../../../assets/js/script";
import {useTranslation, withTranslation} from "react-i18next";
import {
  BarChartOutlined,
  HomeOutlined,
  FolderOpenOutlined,
  FileOutlined,
  UserOutlined,
  MailOutlined,
  GlobalOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import {Modal, notification} from "antd";
import variables from "../../../_constants/variables";
import localOrSessionStore from "../../../_helpers/localOrSessionStore";
import {authActions, tutorAuthActions} from "../../../_actions";
import {useDispatch} from "react-redux";

// function NavbarLogin(props){
function NavbarLogin({className = ""}) {
  const socket = useRef();
  const storage = localOrSessionStore({key: variables.REMEMBER});
  const userType = storage.getItem(variables.USER_TYPE);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [alert, setAlert] = React.useState(false);
  const [currentCount, setCount] = useState(1);
  const user = JSON.parse(storage.getItem(variables.USER));
  const [api, contextHolder] = notification.useNotification();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    logout();
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const [activeKey, setActiveKey] = React.useState(
    window.location.href.includes("dashboard")
      ? "espacio"
      : window.location.href.includes("students")
        ? "students"
        : window.location.href.includes("informes")
          ? "informes"
          : window.location.href.includes("excel")
            ? "excel"
            : window.location.href.includes("carpeta")
              ? "carpeta"
              : window.location.href.includes("recursos")
                ? "recursos"
                : window.location.href.includes("mensajes")
                  ? "mensajes"
                  : window.location.href.includes("cuenta")
                    ? "cuenta"
                    : "espacio",
  );

  const navData = {
    students: {
      icon: <HomeOutlined />,
      className: "itemMenuNav",
      eventKey: "students",
      route: "/tutorAuth/students",
    },
    espacio: {
      icon: <HomeOutlined />,
      className: "itemMenuNav",
      eventKey: "espacio",
      route: "/admin/dashboard",
    },
    informes: {
      icon: userType === "STUDENT" || userType === "FAMILY" ? <FileOutlined /> : <BarChartOutlined />,
      className: "itemMenuNav",
      eventKey: "informes",
      route: "/admin/informes",
    },
    excel: {
      icon: <FileExcelOutlined />,
      className: "itemMenuNav",
      eventKey: "excel",
      route: "/admin/excel",
    },
    carpeta: {
      icon: <FolderOpenOutlined />,
      className: "itemMenuNav",
      eventKey: "carpeta",
      route: "/admin/carpeta",
    },
    recursos: {
      icon: <GlobalOutlined />,
      className: "itemMenuNav",
      eventKey: "recursos",
      route: "/admin/recursos",
    },
    mensajes: {
      icon: <MailOutlined />,
      className: "itemMenuNav",
      eventKey: "mensajes",
      route: "/admin/mensajes",
    },
    cuenta: {
      icon: <UserOutlined />,
      className: "itemMenuNav",
      eventKey: "cuenta",
      route: "/admin/cuenta",
    },
  };

  const onNavClick = (eventKey) => {
    setAlert(false);
    setActiveKey(eventKey);
    history.push(navData[eventKey].route);
  };

  const dispatch = useDispatch();
  const {t, i18n} = useTranslation();
  useEffect(() => {
    toggleMenu();
  });

  const logout = () => {
    dispatch(userType === "STUDENT" ? authActions.logout() : tutorAuthActions.logout());
  };

  useEffect(() => {
    if (currentCount <= 0) {
      return;
    }
  }, [currentCount]);

  return (
    <>
      {contextHolder}
      <Modal
        className={"modalName modal-question modal-question--xs modal-custom--xs"}
        title={t("cerrarsesiont")}
        okText={t("cerrarsesions")}
        cancelText={t("cancel")}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <p>{t("cerrarsesiona")}</p>
      </Modal>

      <Navbar className={`navbarMenu ${className}`}>
        {/* <div className={"navbar"}> */}
        <div className={"nav-container"}>
          <Navbar.Brand className={"imgLogo"} onClick={() => history.push("/default/index")}>
            <img className={"imgLogo"} src={logo} alt={""} width={"151"} height={"52"} />
          </Navbar.Brand>

          <Nav className={"container-menu"} activeKey={activeKey}>
            <ul className={"menu-items"}>
              <li>
                {userType === "STUDENT" ? (
                  <Nav.Item {...navData["espacio"]} onClick={() => onNavClick("espacio")}>
                    {t("menu.espacio")}
                  </Nav.Item>
                ) : (
                  userType !== "FAMILY" && (
                    <Nav.Item {...navData["students"]} onClick={() => onNavClick("students")}>
                      {t("menu.users")}
                    </Nav.Item>
                  )
                )}
              </li>
              {(userType === "STUDENT" ||
                userType === "FAMILY" ||
                userType === "COUNSELOR" ||
                userType === "CENTER" ||
                userType === "MASTER") && (
                <li>
                  <Nav.Item {...navData["informes"]} onClick={() => onNavClick("informes")}>
                    {userType === "STUDENT" || userType === "FAMILY" ? t("menu.informes") : t("menu.verdatos")}
                  </Nav.Item>
                </li>
              )}
              {userType === "MASTER" && (
                <li>
                  <Nav.Item {...navData["excel"]} onClick={() => onNavClick("excel")}>
                    {t("menu.exportar")}
                  </Nav.Item>
                </li>
              )}
              {userType !== "MASTER" && userType !== "CENTER" && userType !== "FAMILY" && (
                <li>
                  <Nav.Item {...navData["carpeta"]} onClick={() => onNavClick("carpeta")}>
                    {t("menu.carpeta")}
                  </Nav.Item>
                </li>
              )}
              {userType !== "MASTER" && (
                <li>
                  <Nav.Item {...navData["recursos"]} onClick={() => onNavClick("recursos")}>
                    {t("menu.recursos")}
                  </Nav.Item>
                </li>
              )}

              {userType !== "FAMILY" && (
                <li>
                  <Nav.Item {...navData["mensajes"]} onClick={() => onNavClick("mensajes")}>
                    {t("menu.mensajes")}
                  </Nav.Item>
                  {alert && <span className={"badgeAlert"} />}
                </li>
              )}
              {userType !== "MASTER" && userType !== "FAMILY" && (
                <li>
                  <Nav.Item {...navData["cuenta"]} onClick={() => onNavClick("cuenta")}>
                    {t("menu.cuenta")}
                  </Nav.Item>
                </li>
              )}
              <li>
                <Nav.Item className={"itemMenuNav"} eventKey="salir" onClick={showModal}>
                  {t("tcerrars")}
                </Nav.Item>
              </li>
            </ul>
            <div className={"content-button"}>
              <input id={"checkboxMenu"} className={"checkbox"} type="checkbox" name="" />
              <div className={"hamburger"}>
                <span className={"line"}></span>
                <span className={"line"}></span>
                <span className={"line"}></span>
              </div>
            </div>
          </Nav>
        </div>
        {/* </div> */}
      </Navbar>
    </>
  );
}

export default withTranslation()(NavbarLogin);
